import { render, staticRenderFns } from "./PriorityMark.vue?vue&type=template&id=e929b6fc&scoped=true&"
import script from "./PriorityMark.vue?vue&type=script&lang=js&"
export * from "./PriorityMark.vue?vue&type=script&lang=js&"
import style0 from "./PriorityMark.vue?vue&type=style&index=0&id=e929b6fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e929b6fc",
  null
  
)

export default component.exports